import styled from 'styled-components';
import { colors } from 'app/shared/styles/_colors';
import { zindex } from 'app/shared/styles/_zindex';

interface Props {
  isVisible: boolean;
}

export const Overlay = styled.aside`
  visibility: hidden;
  position: fixed;
  top: 91px;
  right: 0;
  left: 0;
  bottom: 0;
  background: ${colors['$hpx-white']};
  overflow: scroll;
  z-index: ${zindex['$z-index-step']};

  ${(props: Props) =>
    props.isVisible === true &&
    `
        visibility: visible;
    `}
`;
